import { Type } from 'class-transformer';
import { YearlySaving } from './yearly-saving.class';

export class SimulationSavings {
	organizationId: string;
	simulationId: string;

	@Type(() => YearlySaving)
	yearlySavings: YearlySaving[];

	baseSavingTotal: number;
	worstCaseSavingTotal: number;
	bestCaseSavingTotal: number;
}
